// Regular expression for basic email validation

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const organizationEmailRegex = /^[a-zA-Z0-9._%+-]+@(hitachi|hitachivantara|hitachids|gmail|)\.(com|in|eu|co\.in)$/;
/**
 * Validates a general email address.
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email is valid, otherwise false.
 */

export const isValidateEmail = (email) => {
  const trimmed = email?.trim();
  // Reject if it contains URL-like patterns
  if (trimmed?.includes("http://") || trimmed?.includes("https://") || trimmed?.includes("/")) {
    return false;
  }
    return emailRegex?.test(trimmed);
};


/**
 * Validates an organization-specific email address.
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email belongs to the specified organization, otherwise false.
 */
export const isValidateOrganizationEmail = (email) => {
  if (!organizationEmailRegex && !organizationEmailRegex.test(email)) {
    return false;
  }
  return true;
};